import service from '@/services/reviews';
import { CONSTS } from '@/helpers/consts';

export default {
  setSelectedProduct: ({ commit, dispatch, state }, payload) => {
    // clear the id filter for next search
    commit('setReviewId', null);
    if (state.reviewsList.selectedProduct == payload) {
      commit('setSelectedProduct', null);
    } else {
      commit('setSelectedProduct', payload);
    }
    dispatch('loadReviewsList');
  },
  setSelectedProducts: async ({ commit, dispatch }, payload) => {
    await commit('setSelectedProducts', payload || []);
    dispatch('loadReviewsListMultipleProducts');
  },
  loadReviewsListMultipleProducts: ({ commit, state }, hideLoading) => {
    if (!hideLoading) commit('setReviewsListLoading', true);
    return service
      .getReviewsListMultipleProducts(
        state.reviewsList.pagination,
        state.productSearch.selectedIds.length > 0 ? state.productSearch.selectedIds : []
      )
      .then(response => commit('loadReviewsListSuccess', response))
      .catch(_ => {
        const {
          pagination,
          numUnpublished,
          carouselReviewsCount,
          importing,
          creditsLeft,
          importQuota,
          progression,
        } = state.reviewsList;

        commit('loadReviewsListSuccess', {
          ...pagination,
          recordsTotal: 1,
          recordsFiltered: 1,
          dashboardReviewsPerPage: pagination.rowsPerPage,
          numUnpublished,
          carouselReviewsCount,
          importing,
          creditsLeft,
          importQuota,
          progression,
        });
      })
      .finally(() => {
        commit('setReviewsListLoading', false);
      });
  },
  loadReviewsList: ({ commit, state }, hideLoading) => {
    if (!hideLoading) commit('setReviewsListLoading', true);
    return service
      .getReviewsList(
        state.reviewsList.pagination,
        state.reviewsList.selectedProduct ? state.reviewsList.selectedProduct.id : null
      )
      .then(response => commit('loadReviewsListSuccess', response))
      .catch(() => {})
      .finally(() => {
        commit('setReviewsListLoading', false);
      });
  },
  resendVerificationEmail(_, payload) {
    return service.resendVerificationEmail(payload);
  },
  resendReviewRequest: payload => {
    return service.resendReviewRequest(payload);
  },
  featureReviewForEmailMarketing: ({ dispatch }, param) => {
    service.featureReviewForEmailMarketing(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  unfeatureReviewForEmailMarketing: ({ dispatch }, param) => {
    service.unfeatureReviewForEmailMarketing(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  incentivizeReview: ({ dispatch }, param) => {
    service.incentivizeReview(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  deactivateIncentivizeReview: ({ dispatch }, param) => {
    service.deactivateIncentivizeReview(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  loadReview: ({ commit }, payload) => {
    commit('setReviewId', payload);
  },
  setReviewsListPagination({ commit }, payload) {
    commit('setReviewsListPagination', payload);
  },
  setReviewsListSearch({ commit }, payload) {
    commit('setReviewsListSearch', payload);
  },
  publishReview: ({ dispatch }, param) => {
    service.postPublishReview(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  unpublishReview: ({ dispatch }, param) => {
    return service.postUnpublishReview(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  deleteReviewAction: ({ dispatch }, param) => {
    return service.postDeleteReview(param).then(() => dispatch('loadReviewsListMultipleProducts'));
  },
  hideReviewAction: ({ dispatch }, param) => {
    return service.postHideReview(param).then(() => dispatch('loadReviewsListMultipleProducts'));
  },
  unhideReviewAction: ({ dispatch }, param) => {
    return service.postUnhideReview(param).then(() => dispatch('loadReviewsListMultipleProducts'));
  },
  addCarouselReviewAction: ({ dispatch }, param) => {
    return service
      .postAddCarouselReview(param)
      .then(() => dispatch('loadReviewsListMultipleProducts'));
  },
  removeCarouselReviewAction: ({ dispatch }, param) => {
    return service
      .postRemoveCarouselReview(param)
      .then(() => dispatch('loadReviewsListMultipleProducts'));
  },
  featureAction: ({ dispatch }, param) => {
    return service.postFeature(param.review_id).then(() => {
      dispatch(
        'increaseFeaturedReviewCounter',
        {},
        {
          root: true,
        }
      );
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  unfeatureAction: ({ dispatch }, param) => {
    service.postUnfeature(param.review_id).then(() => {
      dispatch(
        'increaseFeaturedReviewCounter',
        {},
        {
          root: true,
        }
      );
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  resolveAction: ({ dispatch }, param) => {
    service.postResolve(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  editReviewAction: ({ dispatch }, param) => {
    service.postEditReview(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  commentReviewAction: ({ dispatch }, param) => {
    service.postCommentReview(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  editCommentReviewAction: ({ dispatch }, param) => {
    service.postEditCommentReview(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  editReviewerNameAction: ({ dispatch }, param) => {
    service.postEditReviewerName(param).then(() => {
      dispatch('loadReviewsListMultipleProducts');
    });
  },
  rotateImageAction(_, payload) {
    return service.postImageRotate(payload.reviewId, payload.imageURL);
  },
  deleteImageAction(_, payload) {
    return service.postImageDelete(payload.reviewId, payload.imageURL);
  },
  moveImagesAction(_, payload) {
    return service.postImageMove(payload.reviewId, payload.imageURLs);
  },
  deleteVideoAction(_, payload) {
    return service.postVideoDelete(payload.reviewId);
  },
  setSellerReviewsPagination({ commit }, payload) {
    return commit('setSellerReviewsPagination', payload);
  },
  loadSellerReviews({ commit, state }, loading) {
    if (loading) {
      commit('setSellerReviewsLoading', true);
    }
    return service
      .loadSellerReviews(state.sellerReviews.pagination)
      .then(res => commit('loadSellerReviewsSuccess', res))
      .catch(() => {})
      .finally(() => {
        commit('setSellerReviewsLoading', false);
      });
  },
  deleteReviews({ dispatch }, reviews) {
    service.deleteReviews(reviews.map(review => review.id)).then(() => {
      dispatch('loadSellerReviews');
    });
  },
  unpublishReviews({ dispatch }, reviews) {
    service.unpublishReviews(reviews.map(review => review.id)).then(() => {
      dispatch('loadSellerReviews');
    });
  },
  publishReviews({ rootState }, reviews) {
    // Get number of reviews that would consume import quota
    const quotaRequired = reviews.filter(
      review =>
        review.source != null && review.source != CONSTS.service.aliexpress && !review.published
    ).length;

    if (
      rootState.accountInfo.reviewImportQuotaLeft != null &&
      quotaRequired > rootState.accountInfo.reviewImportQuotaLeft
    ) {
      return Promise.reject();
    } else {
      return service.publishReviews(reviews.map(review => review.id));
    }
  },
  searchProductItem({ commit, dispatch }, product_id_first) {
    commit('setProductSearchLoading', true);
    return service
      .searchProducts(null, product_id_first)
      .then(async res => {
        await commit('searchProductsSuccess', res);
        return dispatch('setItem', res.data[0]);
      })
      .catch(() => {})
      .finally(() => {
        commit('setProductSearchLoading', false);
      });
  },
  setItem({ commit, dispatch }, item) {
    dispatch('setSelectedProducts', [item.id]);
    commit('setProductSearchSelected', [item]);
  },
  searchProducts({ commit, state }) {
    commit('setProductSearchLoading', true);
    return service
      .searchProducts(state.productSearch.query)
      .then(res => commit('searchProductsSuccess', res))
      .catch(() => {})
      .finally(() => {
        commit('setProductSearchLoading', false);
      });
  },
  searchMoveProducts({ commit, state }) {
    commit('setMoveProductSearchLoading', true);
    return service
      .searchProducts(state.moveProductSearch.query)
      .then(res => commit('searchMoveProductsSuccess', res))
      .catch(() => {})
      .finally(() => {
        commit('setMoveProductSearchLoading', false);
      });
  },
  setProductSearch({ commit }, payload) {
    commit('setProductSearch', payload);
  },

  linkReviewsToProduct({ commit, state, dispatch }) {
    const reviews = state.productSearch.selectedReviews;
    service
      .linkReviewsToProduct(
        reviews.map(review => review.id),
        state.productSearch.product.id
      )
      .then(() => {
        commit('hideLinkReviews');
        dispatch('loadSellerReviews');
      });
  },
  unlinkReviews({ dispatch }, reviews) {
    service.unlinkReviews(reviews.map(review => review.id)).then(() => {
      dispatch('loadSellerReviews');
    });
  },
};
